import { useApolloClient, useReactiveVar } from "@apollo/client";
import { v4 as uuid } from "uuid";
import { currentShopifyVersionVar } from "../helpers/client";
import { resolvePlatformName } from "../cache/platformName";
import { AddVariantFragmentDoc } from "../types";
export function useSetVariantsWithDescriptions(productId) {
    const client = useApolloClient();
    const currentShopifyVersion = useReactiveVar(currentShopifyVersionVar);
    return (descriptions) => {
        if (!Array.isArray(descriptions))
            return;
        client.cache.modify({
            id: `Product:${productId}`,
            fields: {
                variants(_existing = []) {
                    return descriptions.map((description) => client.cache.writeFragment({
                        fragment: AddVariantFragmentDoc,
                        data: {
                            id: uuid(),
                            __typename: "Variant",
                            description,
                            additionalCost: { amount: 0 },
                            platformName: resolvePlatformName({}, currentShopifyVersion),
                            platformId: "",
                            curationExcludeProducts: [],
                            curationIncludeVariants: [],
                            curationSearchTerms: "",
                            curationStatus: "APPROVED",
                            curationError: null,
                            flagReason: null,
                        },
                    }));
                },
            },
        });
    };
}
